export function SET_ERROR(state, sendThirdPartyPaymentEmailError) {
    state.sendThirdPartyPaymentEmailError = sendThirdPartyPaymentEmailError;
}
export function SET_SEND_THIRD_PARTY_PAYMENT_SUCCESS(state, sendThirdPartyPaymentEmailSuccess) {
    state.sendThirdPartyPaymentEmailSuccess = sendThirdPartyPaymentEmailSuccess;
}
export function SET_SEND_THIRD_PARTY_PAYMENT_LOADING(state, isSendThirdPartyPaymentEmailLoading) {
    state.isSendThirdPartyPaymentEmailLoading = isSendThirdPartyPaymentEmailLoading;
}
export function SET_SELECTED_EDUCATION(state, selectedEducation) {
    state.selectedEducation = selectedEducation;
}
export default {
    SET_ERROR,
    SET_SEND_THIRD_PARTY_PAYMENT_SUCCESS,
    SET_SEND_THIRD_PARTY_PAYMENT_LOADING,
    SET_SELECTED_EDUCATION,
};
